module.exports = __webpack_public_path__ + "img/type_right_3.ae364cb6.png";